import { render } from "./GosuslugiButton.vue?vue&type=template&id=f810697a&scoped=true"
import script from "./GosuslugiButton.vue?vue&type=script&lang=js"
export * from "./GosuslugiButton.vue?vue&type=script&lang=js"

import "./GosuslugiButton.vue?vue&type=style&index=0&id=f810697a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f810697a"]])

export default __exports__